import { MenuAccess } from 'app/shell/types';

export const shouldShowToolsMenu = (menuAccess: MenuAccess): boolean => {
  return !!menuAccess &&
    Object
      .keys(menuAccess)
      .map<keyof MenuAccess>(v => menuAccess[v])
      .some(v => !!v);
};
